import { DateTime } from 'luxon'
import store from '@/store'

// Helper function to get the store's timezone or fall back to a default
export function getStoreTimezone() {
  const storeTimezone = store.getters['storeModule/timezone']
  return storeTimezone || 'America/New_York' // Default timezone if store timezone not set
}

// Helper function to create a DateTime with the store's timezone
export function getLocalDateTime(dateTime = null) {
  const timezone = getStoreTimezone()
  
  if (dateTime) {
    // If provided a DateTime, ensure it's in the store's timezone
    if (typeof dateTime === 'object') {
      if (dateTime.toJSDate) {
        // It's a Luxon DateTime
        return dateTime.setZone(timezone)
      } else if (dateTime.seconds) {
        // It's a Firestore timestamp
        return DateTime.fromSeconds(dateTime.seconds).setZone(timezone)
      } else {
        // It's a JS Date
        return DateTime.fromJSDate(dateTime).setZone(timezone)
      }
    } else if (typeof dateTime === 'number') {
      // It's seconds or milliseconds
      return dateTime > 10000000000 
        ? DateTime.fromMillis(dateTime).setZone(timezone) // milliseconds
        : DateTime.fromSeconds(dateTime).setZone(timezone) // seconds
    } else {
      // It's a string or something else
      return DateTime.fromISO(dateTime).setZone(timezone)
    }
  }
  
  // Otherwise, return current time in store's timezone
  return DateTime.now().setZone(timezone)
}

// Format a date using the store's timezone
export function formatLocalDate(date, format = 'yyyy-MM-dd') {
  return getLocalDateTime(date).toFormat(format)
}

// Format a time using the store's timezone
export function formatLocalTime(date, format = 'h:mm a') {
  return getLocalDateTime(date).toFormat(format)
}

// Format a date and time using the store's timezone
export function formatLocalDateTime(date, format = 'yyyy-MM-dd h:mm a') {
  return getLocalDateTime(date).toFormat(format)
}

export function isDateBySecondsToday(seconds) {
  const timezone = getStoreTimezone()
  return (
    seconds >=
      DateTime.now().setZone(timezone).startOf('day').toSeconds() &&
    seconds <=
      DateTime.now().setZone(timezone).endOf('day').toSeconds()
  )
}

export function isDateBySecondsInFutureByDays(seconds, days) {
  const timezone = getStoreTimezone()
  return (
    seconds >
      DateTime.now()
        .setZone(timezone)
        .startOf('day')
        .plus({ days: 1 })
        .toSeconds() &&
    seconds <
      DateTime.now()
        .setZone(timezone)
        .endOf('day')
        .plus({ days: days })
        .toSeconds()
  )
}

export function isDateBySecondsInPastByDays(seconds, days) {
  const timezone = getStoreTimezone()
  return (
    seconds >=
      DateTime.now()
        .setZone(timezone)
        .startOf('day')
        .minus({ days: days })
        .toSeconds() &&
    seconds <
      DateTime.now().setZone(timezone).startOf('day').toSeconds()
  )
}

export var Objectifier = (function () {
  // Utility method to get and set objects that may or may not exist
  var objectifier = function (splits, create, context) {
    var result = context //|| self (window) // maybe || window || self || {} ??
    for (var i = 0, s; result && (s = splits[i]); i++) {
      result = s in result ? result[s] : create ? (result[s] = {}) : undefined
    }
    return result
  }

  return {
    // Creates an object if it doesn't already exist
    set: function (name, value, context) {
      var splits = name.split('.'),
        s = splits.pop(),
        result = objectifier(splits, true, context)
      return result && s ? (result[s] = value) : undefined
    },
    get: function (name, create, context) {
      return objectifier(name.split('.'), create, context)
    },
    exists: function (name, context) {
      return this.get(name, false, context) !== undefined
    }
  }
})()

export var groupBy = function (arr, criteria) {
  return arr.reduce(function (obj, item) {
    // Check if the criteria is a function to run on the item or a property of it
    var key = typeof criteria === 'function' ? criteria(item) : item[criteria]
    if (key === null) return obj
    // If the key doesn't exist yet, create it
    if (!Object.prototype.hasOwnProperty.call(obj, key)) {
      obj[key] = []
    }

    // Push the value to the object
    obj[key].push(item)

    // Return the object to the next item in the loop
    return obj
  }, {})
}

export function compare(obj1, obj2) {
  //Loop through properties in object 1
  console.log(obj1, obj2)
  for (var p in obj1) {
    console.log(p)
    try {
      //Check property exists on both objects
      if (
        !Object.prototype.hasOwnProperty.call(obj1, p) ||
        !Object.prototype.hasOwnProperty.call(obj2, p)
      ) {
        console.log('false A')
        return false
      }
      console.log(obj1[p])
      console.log(typeof obj1[p])
      switch (typeof obj1[p]) {
        //Deep compare objects
        case 'object':
          if (!compare(obj1[p], obj2[p])) {
            console.log('false B')
            return false
          }
          break
        //Compare function code
        case 'function':
          if (
            typeof obj2[p] == 'undefined' ||
            (p != 'compare' && obj1[p].toString() != obj2[p].toString())
          ) {
            console.log('false C')
            return false
          }
          break
        //Compare values
        default:
          console.log('default')
          if (obj1[p] != obj2[p]) {
            console.log('false D')
            return false
          }
      }
    } catch {
      console.log(obj1, obj2)
      throw Error('error A')
    }
  }
  //Check object 2 for any extra properties
  for (var pp in obj2) {
    console.log(obj2, obj1, pp)
    if (typeof obj1[pp] == 'undefined') return false
  }
  return true
}

export function floatify(number, decimalPlaces = 2) {
  try {
    return Number(
      Math.round(parseFloat(number + 'e' + decimalPlaces)) +
        'e-' +
        decimalPlaces
    )
    //return parseFloat(number.toFixed(decimalPlaces))
  } catch {
    return null
  }
}

export function percentChange(a, b) {
  return floatify(100 * (Math.abs(a - b) / a))
}

export function firebaseDocumentIncludes(name) {
  if (!name) return false
  else return true
}

const WEEKDAY_NAMES = [
  'monday',
  'tuesday',
  'wednestday',
  'thursday',
  'friday',
  'saturday',
  'sunday'
]

export function swapNumberAndWeekday(value) {
  try {
    return typeof value === 'string'
      ? WEEKDAY_NAMES.indexOf(value.toLowerCase())
      : WEEKDAY_NAMES[value]
  } catch (error) {
    throw new Error(error) // return undefined?
  }
}

export function arraysMatch(arr1, arr2) {
  // Check if the arrays are the same length
  if (arr1.length !== arr2.length) return false

  // Check if all items exist and are in the same order
  for (var i = 0; i < arr1.length; i++) {
    if (arr1[i] !== arr2[i]) return false
  }

  // Otherwise, return true
  return true
}

export function to(promise) {
  return promise
    .then((data) => {
      return [null, data]
    })
    .catch((err) => [err])
}

export function newId() {
  // Alphanumeric characters
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  let autoId = ''
  for (let i = 0; i < 20; i++) {
    autoId += chars.charAt(Math.floor(Math.random() * chars.length))
  }
  return autoId
}

export function formatHour(time) {
  if (typeof time === 'string') time = Number(time)
  if (typeof time !== 'number') return null
  if (time > 24 || time < 1) return null

  if (time < 12) {
    return `${time}am`
  } else if (time == 24) {
    return `12am`
  } else if (time == 12) {
    return `12pm`
  } else {
    return `${time - 12}pm`
  }
}

export function adjustHour(hour = null, adjustment = null) {
  if (typeof hour != 'number' || isNaN(hour)) throw Error('Hour not a number.')
  if (hour > 23 || hour < 0) throw Error('Hour is not between 0 & 23.')
  hour += adjustment
  if (hour > 24) hour -= 24
  if (hour < 0) hour += 24
  return hour
}

export function adjustHourLocalToUTC(hour, adjustment = 5) {
  return adjustHour(hour, adjustment)
}

export function adjustHourUTCToLocal(hour, adjustment = -5) {
  return adjustHour(hour, adjustment)
}

export function capitalize(str) {
  if (!str) return ''
  return str.charAt(0).toUpperCase() + str.slice(1)
}

export function lowercase(str) {
  if (!str) return ''
  return str.toLowerCase()
}

export function validateEmail(str) {
  var mailformat = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/
  if (str.match(mailformat)) {
    return true
  } else {
    return false
  }
}

export function validatePhone(str) {
  // var phoneFormat = /^[2-9]\d{2}-\d{3}-\d{4}$/
  var phoneFormat = /^[2-9]\d{9}$/
  if (str.replace(/-/g, '').match(phoneFormat)) {
    return true
  } else {
    return false
  }
}

export function downloadCsv({ filename = null, data = null }) {
  if (!filename || !data) return
  var hiddenElement = document.createElement('a')
  // critical to use encodeURIComponent instead of just encodeURI for # signs
  hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(data)
  hiddenElement.target = '_blank'
  hiddenElement.download = `${filename}.csv`
  hiddenElement.click()
  hiddenElement.remove()
}

export function eitherDate(d) {
  return dateFix(d.deliveryDate) || dateFix(d.orderDate)
}
export function dateFix(d) {
  if (d === null) return false
  return toDate(d) || Object.prototype.hasOwnProperty.call(d, 'seconds')
    ? new Date(d.seconds * 1000)
    : d === ''
    ? false
    : false
}
export function toDate(d) {
  try {
    return d.toDate() // isValid
  } catch {
    return d instanceof Date && !isNaN(d) // isValidDate
  }
}
export function toDateString(d) {
  try {
    return d.toDateString()
  } catch {
    return 'N/A'
  }
}

function formatDate(date) {
  if (!date) return ''
  if (date.seconds) {
    // Handle Firestore Timestamp
    date = new Date(date.seconds * 1000)
  }
  if (date instanceof Date) {
    return DateTime.fromJSDate(date)
      .setZone('America/New_York')
      .toFormat('MM/dd/yyyy')
  }
  return ''
}

function formatDateTime(date) {
  if (!date) return ''
  if (date.seconds) {
    date = new Date(date.seconds * 1000)
  }
  if (date instanceof Date) {
    return DateTime.fromJSDate(date)
      .setZone('America/New_York')
      .toFormat('MM/dd/yyyy HH:mm')
  }
  return ''
}

const usd = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2
})

const percent = new Intl.NumberFormat('en-US', {
  style: 'percent',
  minimumFractionDigits: 2
})

export function format(value = 0, style = 'currency') {
  switch (style) {
    case 'currency':
      return usd.format(value)
    case 'percent':
      return percent.format(value)
    default:
      throw 'Incorrect format style passed!'
  }
}

export default {
  firebaseDocumentIncludes,
  swapNumberAndWeekday,
  arraysMatch,
  to,
  newId,
  formatHour,
  formatDate,
  formatDateTime,
  Objectifier,
  groupBy,
  compare,
  floatify,
  capitalize,
  lowercase,
  validateEmail,
  downloadCsv,
  eitherDate,
  dateFix,
  toDate,
  toDateString,
  format,
  WEEKDAY_NAMES
}
